import React from "react";
import {useNavigate} from "react-router-dom";
import styled from "styled-components";
import PageHeader from "../../components/organisms/PageHeader";
import map from "../../assets/images/nature-pool-main-img.png";
import spot15 from "../../assets/images/mp-center.png";
import spot16 from "../../assets/images/mp-nature-swiming.png";
import spot17 from "../../assets/images/mp-nature-ground.png";
import toilet from "../../assets/images/toilet.png";
import MapTooltip from "../../components/atoms/MapTooltip";
import pool1 from "../../assets/images/nature-0629-01.jpg"
import pool2 from "../../assets/images/nature-0629-5.jpg"
import SubTitle from "../../components/atoms/SubTitle";
import Btn from "../../components/atoms/Btn";
import {device} from "../../assets/styles/media";
import {useMediaQuery} from "react-responsive";
import LeftSection from "../../components/organisms/LeftSection";
import NoticeBox from "../../components/molecules/NoticeBox";


const Section = styled.section`
    display: flex;
    margin-top: 60px;
    margin-bottom: 40px;

    ${device.tablet} {
        flex-direction: column;
    }

    ${device.mobile} {
        flex-direction: column;
        margin-bottom: 60px;
    }
`;
const Section2 = styled(Section)`
    display: block;
    margin-top: 60px;
    margin-bottom: 140px;

    ${device.mobile} {
        margin-bottom: 50px;
    }
`;

const MapBox = styled.div`
    position: relative;
    overflow: hidden;
    margin: -2vw auto 0;
`;
const MapBg = styled.img`
    width: 1440px;
    height: 750px;
    vertical-align: top;

    ${device.tablet} {
        width: 100%;
        height: 500px;
    }

    ${device.mobile} {
        width: 100%;
        height: auto;
    }

`;
const MapSpot = styled.span`
    position: absolute;
    cursor: pointer;
    display: inline-block;
    left: ${({left}) => left};
    top: ${({top}) => top};
    width: ${({width}) => width};
    z-index: ${({zIndex}) => zIndex};
    transition: 0.4s ease;

    img {
        transition: 0.4s ease;
        width: 100%;

        &:hover {
            transform: scale(1.1);
        }
    }
`;

const TooltipLabel = styled.div`
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: #322a6f;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 14px;
    color: #f5ab18;
    white-space: nowrap;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    z-index: 99;

    ${device.mobile} {
        zoom: 0.5;
    }
`;
const PcOnly = styled.br`
    display: inline;
    ${device.mobile}{
        display: none;
    }
`;

const NaturePool = () => {
    const navigate = useNavigate();
    const isTablet = useMediaQuery({maxWidth: 1023});
    const navList = [
        {
            name: "네이처풀 소개",
            link: "/map/naturepool"
        },
        {
            name: "이용안내",
            link: "/map/naturepool/guide"
        },
        {
            name: "시설안내",
            link: "/map/naturepool/facility"
        },
    ];
    const mapSpots = [
        {
            id: "map-spot15",
            text: "편의시설&먹거리",
            link: "/map/facility",
            imgSrc: spot15,
            left: "40.5%",
            top: "9.5%",
            width: "10%",
            delay: "0.9s",
            zIndex: 3
        },
        {
            id: "map-spot16",
            text: "수영장&카페, 여름&대여시설",
            link: "/map/naturepool/facility",
            imgSrc: spot16,
            left: "25.3%",
            top: "27.1%",
            width: "24.4%",
            delay: "1.2s",
            // zIndex: 3
        },
        {
            id: "map-spot17",
            text: "네이처풀 운동장",
            link: "/map/playground",
            imgSrc: spot17,
            left: "46%",
            top: "32%",
            width: "17.4%",
            delay: "1.6s",
            zIndex: 3
        },
        {
            id: "toilet01",
            text: "",
            imgSrc: toilet,
            left: "43%",
            top: "11.2%",
            width: "2.5%",
            zIndex: 7
        },
        {
            id: "toilet02",
            text: "",
            imgSrc: toilet,
            left: "40.3%",
            top: "53.8%",
            width: "2.5%",
            zIndex: 7
        },
    ];
    const textList = (
        <>
            네이처풀은 반려견과 함께 자연의 아름다움을 누릴 수 있는 반려견 동반
            <PcOnly/>
            수영장입니다. 울창한 숲 한가운데, 조용히 자리 잡은 넓고 푸른 수영장은 마치
            깊은 숲속에 숨겨진 커다란 호수처럼 신비로움을 자아냅니다.
            <br/><br/>
            무더운 여름날, 네이처풀을 거닌다면 저멀리 어딘가에 있을 법한 그 이국적인&nbsp;
            <PcOnly/>
            모습에 시선을 빼앗길지 모릅니다. 동남아 해변가를 연상 시키는 방갈로와&nbsp;
            <PcOnly/>
            썬베드, 파라솔 등 휴양 시설이 뜨거운 태양이 내리쬐는 한여름에도 시원하고&nbsp;
            <PcOnly/>
            아늑한 시간을 선물합니다.
            <br/><br/>
            네이처풀은 편안한 휴식 + 재미있는 놀이를 위한 모든 것을 갖춘 공간입니다.&nbsp;
            <PcOnly/>
            두개의 수영장과 반려견과 함께 식사할 수 있는 네이처 푸드테라스 및 샤워실을 &nbsp;
            <PcOnly/>
             비롯한 편의시설, 운동장 등을 네이처풀 하나의 공간에서 모두 이용하실 수
            <PcOnly/>
            있습니다.
        </>
    );

    const limitList = [
        {
            item: '중소형견과 대형견이 입장할 수 있는 날이 나뉘어 운영되므로, 이용에 참고 부탁드립니다.',
        },
        {
            item: "네이처풀 이용 시 주차는 박물관동 주차장에 하신 후, 셔틀버스로 네이처풀↔박물관 이동을 부탁드립니다.",
        },
        {
            item: '네이처풀 티켓 구매고객은 강아지숲 전 구역을 이용할 수 있습니다.'
        },
    ];

    return (
        <>
            <PageHeader
                bTitle="관람"
                detail="네이처풀"
                desc="강아지숲 네이처풀을 안내해 드립니다."
                list={navList}
            />
            <Section>
                <MapBox>
                    <MapBg src={map}/>
                    {mapSpots.map((spot) => (<>
                            {!isTablet && <MapTooltip
                                id={spot.id}
                            />}
                            <MapSpot
                                key={spot.id}
                                onClick={spot.link && (() => navigate(spot.link))}
                                style={{animationDelay: spot.delay}}
                                left={spot.left}
                                top={spot.top}
                                width={spot.width}
                                zIndex={spot.zIndex}
                                data-tooltip-id={spot.id}
                                data-tooltip-content={spot.text}
                            >
                                <img src={spot.imgSrc} alt={spot.text}/>
                                {isTablet && spot.text && <TooltipLabel>{spot.text}</TooltipLabel>}
                            </MapSpot>
                        </>
                    ))}
                </MapBox>
            </Section>

            {/*section 1*/}
            <LeftSection
                title="네이처풀"
                enTitle="Naturepool"
                textList={textList}
                img1={pool1}
                img2={pool2}
            />

            {/*네이처풀은 사전 예약제로 운영됩니다.*/}
            <Section2>
                <SubTitle text={"네이처풀은 사전 예약제로 운영됩니다."}/>
                <NoticeBox list={limitList}/>
                <Btn text={"네이버 예약 바로가기"}
                     onClick={() => window.open("https://map.naver.com/p/entry/place/1474858219?placePath=%2Fhome&c=15.00,0,0,0,dh", "_blank")}/>
            </Section2>
        </>
    );
};

export default NaturePool;
